export const BR_VISIT = 'visit';
export const BR_NEW_TRANSFER_BUTTON_CLICKED = 'new-transfer-button-clicked';
export const BR_ANTIFRAUD_PROTECTION_ERROR = 'antifraud_protection_error';

// Registration & Login
export const BR_REG_SUCCESS = 'reg-success';

// Repeat transfer
export const BR_TRANSFER_REPEAT_START = 'transfer-repeat-start';

// New transfer
export const BR_NEW_TRANSFER_START = 'new-transfer-start';
export const BR_SEND_SUCCESS = 'send-success';
export const BR_TEMP_UNAVAILABLE_PROV_SELECTED = 'temporarily_unavailable_provider_selected';

// Calculator
export const BR_SEND_MONEY_FROM_DEFAULT = 'send-money-from-default';
export const BR_SEND_MONEY_TO_DEFAULT = 'send-money-to-default';
export const BR_SEND_MONEY_FROM = 'send-money-from';
export const BR_SEND_MONEY_TO = 'send-money-to';
export const BR_SEND_MONEY_FROM_AMOUNT = 'send-money-from-amount';
export const BR_SEND_MONEY_TO_AMOUNT = 'send-money-to-amount';
export const BR_SEARCH_NO_COUNTRY_FROM = 'search-no-country-from';
export const BR_SEARCH_NO_COUNTRY_TO = 'search-no-country-to';

// Referral
export const BR_REFERRAL_SCREEN_PRESS_ADD = 'ref-screen-press-add';

//STRAPI Banner
export const BR_BANNER_EXTRA_BONUS_CLOSED = 'banner_extra_bonus_closed';
export const BR_BANNER_EXTRA_BONUS_PRESSED_T_AND_C = 'banner_extra_bonus_pressed_t&c';
export const BR_BANNER_EXTRA_BONUS_PRESSED_ARROW = 'banner_extra_bonus_pressed_arrow';

//System
export const BR_SYSTEM_GA_DOWN_RETRY = 'system_ga_down_retry';
